import styled from 'styled-components';

export const NavContainer = styled.div`
  align-items: center;
  display: flex;
  padding: 0 ${props => props.theme.space.s5};
  width: 100%;
`;

export const ButtonWithLinkAppearance = styled('button').attrs({ type: 'button' })`
  appearance: none;
  color: currentColor;
  padding: 0;
  border: none;
  background-color: inherit;
  font-family: ${props => props.theme.fonts.circular};
  font-weight: ${props => props.theme.fontWeights.book};
`;
